// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { capitalize } from 'lodash';
import cx from 'classnames';

import Checkbox from 'components/Checkbox';
import { DisabledTooltipLayer } from './SelectFromList';
import EventTracking from 'lib/EventTracking';
import MediaObject from 'components/MediaObject';
import { selectRecipient } from 'reducers/roleBasedMessagingSearch';
import Text from 'components/Text';
import UserAvatar from 'users/components/UserAvatar';
import { ComposerContext } from './ComposerContext';
import type { UIEventContext } from './ComposerContext';

import type { IndividualRecipient, MessageFilterType } from 'reducers/roleBasedMessagingSearch';

type Props = {
  recipient: IndividualRecipient,
  recipientIsSelected: boolean,
  disabledCopy: ?(string | React.Element<any>),

  // Redux dispatchers
  onSelectRecipient: (recipient: IndividualRecipient, filter: ?MessageFilterType) => *,
};

class IndividualRecipientItem extends React.Component<Props, *> {
  logSelectionEvent = (uiEventContext: UIEventContext) => {
    if (this.props.recipientIsSelected) {
      EventTracking.trackKey('announcements.share_to.individual.unselect.click', uiEventContext);
      return;
    }
    EventTracking.trackKey('announcements.share_to.individual.select.click', uiEventContext);
  };

  handleSelection = () => {
    this.props.onSelectRecipient(this.props.recipient, undefined);
  };

  render() {
    const { recipient, disabledCopy } = this.props;
    const { member } = recipient;
    const user = member.getUser();
    const memberName = member.getName();

    const component = (
      <ComposerContext.Consumer>
        {composerContext => (
          <li
            className={cx('RecipientItem', {
              'RecipientItem--disabled': !!disabledCopy,
            })}
            onClick={() => {
              this.handleSelection();
              this.logSelectionEvent(composerContext.getUIEventContext());
            }}>
            <MediaObject figure="right" center>
              <MediaObject gutter="small" center>
                <UserAvatar size="medium" user={user.toJSON()} />
                <div>
                  <Text size="small" element="div" truncate>
                    {memberName}
                  </Text>
                  <Text size="xsmall" element="div" color="eclipse">
                    {capitalize(member.getRole())}
                  </Text>
                </div>
              </MediaObject>
              <Checkbox onChange={this.handleSelection} checked={this.props.recipientIsSelected} />
            </MediaObject>
          </li>
        )}
      </ComposerContext.Consumer>
    );
    return disabledCopy ? (
      <DisabledTooltipLayer text={disabledCopy}>{component}</DisabledTooltipLayer>
    ) : (
      component
    );
  }
}

const mapDispatchToProps = (dispatch: Function) => {
  return bindActionCreators(
    {
      onSelectRecipient: selectRecipient,
    },
    dispatch
  );
};

export { IndividualRecipientItem };

export default connect(
  undefined,
  mapDispatchToProps
)(IndividualRecipientItem);
